// @flow

import * as React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';

import { Title, Toggle, Tooltip, Dropdown } from '../core';
import { getAdPartners } from '../../../main/actions/AdPartnerActions';
import { fetchCountries } from '../../../main/actions/AgencyRelationshipActions';
import { getPartnerName } from '../../../main/screens/ScreenAdPartner/utils';
import type { AgencyRelationshipReducer } from '../../../main/types/agencyRelationshipTypes';
import type {
  AdPartnerReducer,
  AdPartner
} from '../../../main/types/adPartnerTypes';

import type {
  Filters,
  FilterToggles,
  UiRoleId
} from '../../../main/types/accessControlTypes.js';

import {
  AD_NETWORKS,
  LOCATION,
  UI_DATA_RESTRICTION_OPTIONS,
  UI_DATA_RESTRICTIONS_HEADING,
  ROLE_IDS
} from '../../support/accessControlConstants';

type ReduxProps = {
  fetchCountries: () => void,
  agencyRelationship: AgencyRelationshipReducer,
  ad_partner: AdPartnerReducer,
  getAdPartners: (payload: { partner: ?AdPartner }) => Promise<any>
};

type Props = {
  onDataChange: (key: string, value: any) => void,
  updateLocations: (values: Array<string>) => void,
  updateAdNetworks: (values: Array<string>) => void,
  filters: Filters,
  filterToggles: FilterToggles,
  uiRoleId: UiRoleId
} & ReduxProps;

class EditAccessDataRestrictionsUI extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.fetchCountries();
    this.props.getAdPartners({ partner: null });
  }

  _getFilteredAdNetworks() {
    const { partners = [] } = this.props.ad_partner;

    return partners
      .filter(p => ['active', 'tune'].includes(p.status) || p.custom_publisher)
      .map(p => ({ label: getPartnerName(p), value: p.machine_name }));
  }

  onToggleClick = (id: string) => {
    this.props.onDataChange('filterToggles', {
      ...this.props.filterToggles,
      [id]: !this.props.filterToggles[id]
    });
  };

  render() {
    const props = this.props;
    return (
      <div>
        <Title label={UI_DATA_RESTRICTIONS_HEADING} />
        {UI_DATA_RESTRICTION_OPTIONS.map(option => (
          <div key={option.id}>
            <div className="access-control__data-restrictions-row">
              <div className="permissions-table__label">
                {option.label}
                <Tooltip title={option.tooltip} className="h_mb-5" />
              </div>
              <div className="permissions-table__label">
                <Toggle
                  isRight={props.filterToggles[option.id]}
                  onClick={e => this.onToggleClick(option.id)}
                  testid={`access-data-restrictions__agency-${option.id}`}
                  disabled={props.uiRoleId !== ROLE_IDS.CUSTOM}
                />
              </div>
            </div>
            {option.id === LOCATION && props.filterToggles[option.id] ? (
              <Dropdown
                multi={true}
                options={props.agencyRelationship.countries}
                value={props.filters[LOCATION]}
                outerClassName="access-control__data-restrictions-select"
                i13nLabel="Locations"
                testid="access-control__data-restrictions-locations"
                onChange={props.updateLocations}
              />
            ) : null}
            {option.id === AD_NETWORKS && props.filterToggles[option.id] ? (
              <Dropdown
                multi={true}
                options={this._getFilteredAdNetworks()}
                value={props.filters[AD_NETWORKS]}
                outerClassName="access-control__data-restrictions-select"
                i13nLabel="Locations"
                testid="access-control__data-restrictions-adnetworks"
                onChange={props.updateAdNetworks}
              />
            ) : null}
          </div>
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCountries: () => dispatch(fetchCountries()),
    getAdPartners: (payload: { partner: ?Object }) =>
      dispatch(getAdPartners(payload))
  };
};

export default connect(
  R.pick(['agencyRelationship', 'ad_partner']),
  mapDispatchToProps
)(EditAccessDataRestrictionsUI);

// export default EditAccessDataRestrictionsUI;
